import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Home from "../pages/Week/Home";
import Detail from "../pages/Week/Detail";
import Edit from "../pages/Week/Edit";

const Week = () => {
  return (
    <div className="Week">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<Detail />} />
        <Route path="/:id/edit" element={<Edit />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Week;
